// main.js
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/font.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import httpRequest from '@/utils/httpRequest'
import api from '@/utils/api'
import animated from 'animate.css'
import i18n from './plugins/i18n'
import store from './store' // 引入 Vuex 存储
import VueCropper from 'vue-cropper'

Vue.use(VueCropper)
Vue.use(animated)
Vue.config.productionTip = false
Vue.use(ElementUI)

// 挂载全局
Vue.prototype.$http = httpRequest // ajax 请求方法
Vue.prototype.$api = api // ajax 请求方法

// 是否为手机端
const screenWidth = window.innerWidth
console.log(screenWidth)
// 移动端引入公共样式
if (screenWidth <= 750) {
  require('@/assets/css/mobile.scss') // 手机端独立
} else {
  require('@/assets/css/pc.css')
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, // 使用 Vuex 存储
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js